import React from "react";
import { Row, Col } from "react-bootstrap";
import { FiFilter } from "react-icons/fi";

const SettlementFilters = ({
  castingDirectors,
  castingDirectorFilter,
  setCastingDirectorFilter,
  statusFilter,
  setStatusFilter,
  typeFilter,
  setTypeFilter,
  onReset,
  onApply
}) => {
  return (
    <div className="bma-card mb-4">
      <div className="bma-card-body">
        <h2 className="bma-card-title mb-3">Filters</h2>
        <Row className="g-3 mb-3">
          <Col md={4}>
            <label className="bma-label">Casting Director</label>
            <select
              className="bma-select"
              value={castingDirectorFilter}
              onChange={(e) => setCastingDirectorFilter(e.target.value)}
            >
              <option value="">All Casting Directors</option>
              {castingDirectors.map((cd) => (
                <option key={cd.id} value={cd.id}>{cd.name}</option>
              ))}
            </select>
          </Col>

          <Col md={4}>
            <label className="bma-label">Settlement Status</label>
            <select
              className="bma-select"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">All Statuses</option>
              <option value="Settlement Initiated">Settlement Initiated</option>
              <option value="Settlement Completed">Settlement Completed</option>
              <option value="Failed">Failed / Cancelled</option>
            </select>
          </Col>

          <Col md={4}>
            <label className="bma-label">Settlement Type</label>
            <select
              className="bma-select"
              value={typeFilter}
              onChange={(e) => setTypeFilter(e.target.value)}
            >
              <option value="">All Types</option>
              <option value="By Project">By Project</option>
              <option value="Weekly">Weekly</option>
              <option value="Monthly">Monthly</option>
            </select>
          </Col>
        </Row>

        <div className="d-flex justify-content-end gap-2">
          <button type="button" className="bma-btn-outline" onClick={onReset}>
            Reset
          </button>
          <button type="button" className="bma-btn-red" onClick={onApply}>
            <FiFilter /> Apply Filters
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettlementFilters;